import React from 'react';
import { SvgIcon, Typography } from '@material-ui/core';
import { useStyle } from './contact-summary-item.style';

type ContactSummaryItemProps = {
    icon: React.ReactNode;
    text: string;
    link?: boolean;
    linkValue?: string;
    title?: string;
    onClick?: () => void;
};

export const ContactSummaryItem: React.FC<ContactSummaryItemProps> = ({
    title,
    icon,
    text,
    link,
    linkValue,
    onClick,
}) => {
    const classes = useStyle();

    return (
        <li className={classes.content}>
            <SvgIcon className={classes.icon} color="primary">
                {icon}
            </SvgIcon>
            <div>
                {title && <Typography className={classes.title}>{title}</Typography>}
                {link ? (
                    <a onClick={onClick} href={linkValue}>
                        {text}
                    </a>
                ) : (
                    <Typography className={classes.text}>{text}</Typography>
                )}
            </div>
        </li>
    );
};
